import React from 'react';
import {connect} from "react-redux";
import language from "../../languages/language";
import datalanguage from "../../languages/datalanguages";
import {Alert, Button, Col, Row, Typography } from "antd";
import PublicLayout from "../Public";
import requestCertificate from "../../actions/requestCertificate";
import TitleAndInfo from "../TitleAndInfo/TitleAndInfo";
import startOverClient from "../../actions/startOverClient";

class Confirmation extends React.Component
{
    getColumn=(fields)=>
    {
        console.log(fields);
      return <Col span={11}>
              {Object.keys(fields).map(key=><>
                  <Row style={{alignItems:'center'}}>
                      <Col xs={24} sm={24} md={12} lg={12}>
                          <Typography style={{fontWeight: "bold"}}>{fields[key]}</Typography>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12}>{this.props.info[key]}</Col>
                  </Row>
              </>)}
      </Col>;
    };

    render()
    {
        return <PublicLayout title={'logo'} size={'large'}>
            <Row justify={'center'}  type={'flex'}>
                <TitleAndInfo info={language[this.props.language].confirmationLabel}/>
                <Row style={{width:'100%',fontSize:'15px'}} justify={'center'}  type={'flex'}>
                    {this.getColumn(datalanguage[this.props.language].dataLabels.first)}
                    <Col span={2}/>
                    {this.getColumn(datalanguage[this.props.language].dataLabels.last)}
                </Row>
                <Alert style={{maxHeight:200,fontSize:'15px',textAlign:'justify',paddingLeft:0}} className={'mb-10 info color-primary'}
                       message={language[this.props.language].confirmationLabel2} type="info"/>
            </Row>
            <Row justify={'space-around'} type={'flex'}>
                <Button type="ghost" style={{width:300}} onClick={()=>this.props.startOverClient(this.props.info.userName)}>
                    {language[this.props.language].cancelLabel}
                </Button>
                <Button type="primary" style={{width:300}} onClick={()=>this.props.requestCertificate(this.props.info)}>
                    {language[this.props.language].nextLabel}
                </Button>
            </Row>
        </PublicLayout>
    }
}
function mapStateToProps(state) {
    return {
        language: state.auth.language,
        info: state.info
    }
}
function mapDispatchToProps(dispatch) {
    return {
        requestCertificate: (formValues) => dispatch(requestCertificate(formValues)),
        startOverClient:(userName)=>dispatch(startOverClient(userName)),
        dispatch
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Confirmation);